// 0. JAVASCRIPT LAYER [ 0.00 PRELOAD SCRIPTS ] #######################################################################

// 0.1. PRELOADER -----------------------------------------

jQuery('html').addClass('preloader');

// 0.1. END -----------------------------------------------

// 0.2 LOAD FUNCTIONS -------------------------------------

// 0.2. END -----------------------------------------------

/*
 * JavaScript Templates Runtime
 * https://github.com/blueimp/JavaScript-Templates
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */

/* global define */

;(function ($) {
    'use strict'
    var tmpl = function (id, data) {
        var f = tmpl.cache[id]
        return data ? f(data, tmpl) : function (data) {
            return f(data, tmpl)
        }
    }
    tmpl.cache = {}
    tmpl.encReg = /[<>&"'\x00]/g // eslint-disable-line no-control-regex
    tmpl.encMap = {
        '<': '&lt;',
        '>': '&gt;',
        '&': '&amp;',
        '"': '&quot;',
        "'": '&#39;'
    }
    tmpl.encode = function (s) {
        return (s == null ? '' : '' + s).replace(
            tmpl.encReg,
            function (c) {
                return tmpl.encMap[c] || ''
            }
        )
    }
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return tmpl
        })
    } else if (typeof module === 'object' && module.exports) {
        module.exports = tmpl
    } else {
        $.tmpl = tmpl
    }
}(this))
// 0. JAVASCRIPT LAYER [ 0.02 DEVICE CHECK ] ##########################################################################
    
// 0.1. DEVICE CHECK --------------------------------------------------------------------------------------------------

function initDeviceCheck() {

  var deviceAgent = navigator.userAgent.toLowerCase();

  jQuery('html').addClass('desktop');

  if (deviceAgent.match(/(iphone|ipod|ipad)/)) {
    jQuery('html').removeClass('desktop');
    jQuery('html').addClass('ios');
    jQuery('html').addClass('mobile');
  }

  if (deviceAgent.match(/android/)) {
    jQuery('html').removeClass('desktop');
    jQuery('html').addClass('android');
    jQuery('html').addClass('mobile');
  }

  if (deviceAgent.match(/blackberry/)) {
    jQuery('html').removeClass('desktop');
    jQuery('html').addClass('blackberry');
    jQuery('html').addClass('mobile');
  }

  if (deviceAgent.match(/(symbianos|^sonyericsson|^nokia|^samsung|^lg)/)) {
    jQuery('html').removeClass('desktop');
    jQuery('html').addClass('mobile');
  }

}

// 0.1. END -----------------------------------------------------------------------------------------------------------
  
// 0.0 END ############################################################################################################

// 0. JAVASCRIPT LAYER [ 0.03 EQUAL HEIGHTS ] #########################################################################

// A.1. WAIT FOR FINAL EVENT ------------------------------------------------------------------------------------------

if (typeof waitForFinalEvent == "undefined") {
  var waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
      if (!uniqueId) {
        uniqueId = "Don't call this twice without a uniqueId";
      }
      if (timers[uniqueId]) {
        clearTimeout(timers[uniqueId]);
      }
      timers[uniqueId] = setTimeout(callback, ms);
    };
  })();
}

// A.1. END -----------------------------------------------------------------------------------------------------------

// A.2. LIBRARY -------------------------------------------------------------------------------------------------------

/*
    http://codepen.io/micahgodbolt/pen/FgqLc

    Thanks to CSS Tricks for pointing out this bit of jQuery
    http://css-tricks.com/equal-height-blocks-in-rows/
    It's been modified into a function called at page load and then each time the page is resized.
    One large modification was to remove the set height before each new calculation.
*/

var equalheight;
equalheight = function (container) {
  var currentTallest = 0,
    currentRowStart = 0,
    topPosition = 0,
    currentDiv = 0,
    rowDivs = [],
    $el;
  jQuery(container).each(function () {

    $el = jQuery(this);
    jQuery($el).height('auto');
    topPosition = $el.position().top;

    if (currentRowStart != topPosition) {
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPosition;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
};

// A.1. END -----------------------------------------------------------------------------------------------------------

// 0.0 END ############################################################################################################


// 0.2 LOAD FUNCTIONS -------------------------------------

initDeviceCheck();

// 0.2. END -----------------------------------------------

// 0. JAVASCRIPT LAYER [ 0.00 PRELOAD SCRIPTS END ] ###################################################################
// JAVASCRIPT LAYER [APP.JS]  =========================================================================================

jQuery(document).ready(function($) {

  // PRELOADER --------------------------------------------

  $('html').removeClass('preloader');
  $('html').addClass('weee-app');

  // LOAD FUNCTIONS ---------------------------------------
});
// JAVASCRIPT LAYER [APP.JS]  =========================================================================================

// ====== INDEX  ======================================================================================================
// ==
// == A. BURGER MENU
// == B. HOMEPAGE CAROUSEL
// ==
// ====== INDEX  ======================================================================================================

function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this,
			args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

// A. SHOW/HIDE +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

jQuery(document).ready(function ($) {
	// A.1. Clickable cards -----------------------------------------------------------------------------------------

	function clickableCard() {
		// Ensure there are card elements on the page
		if ($(".o-card--clickable").length) {
			// For each card element
			$(".o-card--clickable").each(function () {
				let down, up;
				let link = $(this).find("a"); // Find the anchor tag within the card

				// Bind mousedown event to capture the time when the mouse button is pressed
				$(this).on("mousedown", function () {
					down = Date.now(); // Record the time of the mousedown event
				});

				// Bind mouseup event to determine the duration of the mouse press
				$(this).on("mouseup", function () {
					up = Date.now(); // Record the time of the mouseup event
					// If the press duration is less than 200 milliseconds, navigate to the link
					if (up - down < 200) {
						window.location.href = link.attr("href"); // Redirect to the link
					}
				});
			});
		}
	}

	clickableCard();

	// A.1. END -----------------------------------------------------------------------------------------------------------

	// A.2. GENERAL SHOW --------------------------------------------------------------------------------------------------

	$(".showhide").click(function (e) {
		var target = $(this).attr("href");

		if ($(target).hasClass("hidden")) {
			$(target).removeClass("hidden");
			$(".showhide").addClass("close");
		} else {
			$(target).addClass("hidden");
			$(".showhide").removeClass("close");
		}

		e.preventDefault();
	});

	// A.2. END -----------------------------------------------------------------------------------------------------------

	// A.2.3. MOBILE SHOWHIDE -----------------------------

	(function ($) {
		if ($("html").hasClass("mobile")) {
			$(".a-config").on("click", function () {
				//e.preventDefault();
				if ($(".a-config").hasClass("active")) {
					$(".a-config").removeClass("active");
					$("body").removeClass("fixed");
				} else {
					$(".a-config").addClass("active");
					$("body").addClass("fixed");
				}
			});
		}
	})(jQuery);

	// A.2.3. END -----------------------------------------

	// A.2. END -----------------------------------------------------------------------------------------------------------

	// A.3. SCROLL TO LINK ------------------------------------------------------------------------------------------------

	$(".textLink, .bob-backUp").click(function (event) {
		event.preventDefault();

		//calculate destination place
		var dest = 0;
		if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
			dest = $(document).height() - $(window).height();
		} else {
			dest = $(this.hash).offset().top;
		}

		//go to destination
		$("html,body").animate({ scrollTop: dest }, 1000, "swing");

		//add class to burger
		$("#mobi-nav").addClass("hide-nav");
	});

	$(".scroll-to").on("click", function (e) {
		e.preventDefault();
		var link = $(this),
			section_id = link.attr("href");

		$("html, body")
			.stop()
			.animate(
				{
					scrollTop: $(section_id).offset().top - 100,
				},
				500
			);
	});

	//smooth scrolling from css-tricks
	$('a[href*="#"]:not([href="#"])').click(function () {
		if (
			location.pathname.replace(/^\//, "") ==
				this.pathname.replace(/^\//, "") &&
			location.hostname == this.hostname
		) {
			var target = $(this.hash);
			target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
			if (target.length) {
				$("html, body").animate(
					{
						scrollTop: target.offset().top - 100,
					},
					1000
				);
				return false;
			}
		}
	});

	// A.3. END -----------------------------------------------------------------------------------------------------------

	// A.4. STICKY DIVS ---------------------------------------------------------------------------------------------------

	var htmlt = $("html").offset().top;

	$(document).scroll(function () {
		// Hide the logo, and show as you scroll
		var body = $("body");
		if ($(this).scrollTop() > htmlt) {
			if (!body.hasClass("sticky")) {
				body.addClass("sticky");
			}
		} else {
			if (body.hasClass("sticky")) {
				body.removeClass("sticky");
			}
		}
	});

	// A.4. END -----------------------------------------------------------------------------------------------------------

	// A.5. SCREEN SIZE CHECK ---------------------------------------------------------------------------------------------

	var screen = $(window).width();

	// A.5. END -----------------------------------------------------------------------------------------------------------

	// A.6. RESOURCE PATHS ------------------------------------------------------------------------------------------------

	var icons = "assets/includes/icons/";

	// A.6. END -----------------------------------------------------------------------------------------------------------

	// A.7. GOOGLE AUTO COMPLETE ------------------------------------------------------------------------------------------
	$(".sidebar_places_autocomplete").each(function () {
		google.maps.event.addDomListener(
			window,
			"load",
			global_google_places_initialize($(this).attr("id"))
		);
	});
	function global_google_places_initialize(element_id) {
		var input = document.getElementById(element_id);
		var autocomplete = new google.maps.places.Autocomplete(input);
		autocomplete.addListener("place_changed", function () {
			var place = autocomplete.getPlace();
			localStorage.setItem("google_result", JSON.stringify(place));
		});
	}
	// A.7. END -----------------------------------------------------------------------------------------------------------

	// A.8. Isotope Filter System -----------------------------------------------------------------------------------------
	var items = $(".isotope-grid");
	if (items.length) {
		var $grid = items.isotope();
		$(".filter-button-group").on("click", "button, a", function (e) {
			e.preventDefault();
			var filterValue = $(this).data("filter");
			$grid.isotope({ filter: filterValue });
			$(".o-news-filters .m-button-group button").removeClass("active");
			$(this).addClass("active");

			if ($(".ajax_read_more_pr").length) {
				load_more_press_release(e, $(".ajax_read_more_pr"));
			}

			if ($(".ajax_read_more").length) {
				load_more_news(e, $(".ajax_read_more"));
			}

			if ($(".ajax_read_more_rr").length) {
				load_more_rr(e, $(".ajax_read_more_rr"));
			}
		});

		$(".filter-list-group").on("click", "a", function (e) {
			e.preventDefault();
			var filterValue = $(this).data("filter");
			$grid.isotope({ filter: filterValue });
			$("#team-members .filter-list-group li").removeClass("active");
			$(this).parent().addClass("active");
		});
	}

	// A.8. END -----------------------------------------------------------------------------------------------------------

	// A.9. Ajax Load More -----------------------------------------------------------------------------------------------
	function load_more_news(e, button) {
		e.preventDefault();
		(isotope = button.attr("data-isotope-class")),
			(data = {
				action: "loadmore_ajax_handler",
				query: scripts_params.posts,
				page: scripts_params.current_page,
			});
		$.ajax({
			// you can also use $.post here
			url: scripts_params.ajaxurl, // AJAX handler
			data: data,
			type: "POST",
			beforeSend: function (xhr) {
				button.text("Loading..."); // change the button text, you can also add a preloader image
			},
			success: function (data) {
				if (data) {
					button
						.text("View more")
						.parent()
						.parent()
						.siblings(".isotope-grid")
						.append(data); // insert new posts
					if (typeof isotope !== undefined) {
						$("." + isotope)
							.isotope("reloadItems")
							.isotope();
					}
					scripts_params.current_page++;

					if (
						scripts_params.current_page.toString() ===
						scripts_params.max_page.toString()
					) {
						button.remove(); // if last page, remove the button
					}
					initialise_news_listing_cards();

					// you can also fire the "post-load" event here if you use a plugin that requires it
					// $( document.body ).trigger( 'post-load' );
				} else {
					button.remove(); // if no data, remove the button as well
				}
			},
		});
	}
	$(".ajax_read_more").click(function (e) {
		load_more_news(e, $(this));
	});
	// A.9. END ----------------------------------------------------------------------------------------------------------

	// A.10. Latest News -----------------------------------------------------------------------------------------------
	var initLatestNews = function ($block) {
		var articleContent = $block.find(".post-details");
		articleContent.each(function () {
			var content = $(this),
				article = content.parent();
			if ($(window).width() > 1024) {
				var originHeight = content.height();
				if (!content.hasClass("no-cta")) {
					content.height(originHeight);
					article
						.off()
						.on("mouseenter", function () {
							content.height(originHeight + 10).addClass("show-cta");
						})
						.on("mouseleave", function () {
							content.height(originHeight).removeClass("show-cta");
						});
				}
			} else {
				if (!content.hasClass("no-cta")) {
					content.addClass("show-cta");
				}
			}
		});
		$(window).resize(function () {
			articleContent.each(function () {
				var content = $(this);

				content.removeAttr("style");
				if ($(window).width() > 1024) {
					if (!content.hasClass("no-cta")) {
						var originHeight = content.height();
						content.height(originHeight).removeClass("show-cta");
					}
				} else {
					if (!content.hasClass("no-cta")) {
						content.addClass("show-cta");
					}
				}
			});
		});

		$(".m-button-group button")
			.off()
			.on("click", function () {
				$(".m-button-group button").removeClass("active");
				$(this).addClass("active");
			});
	};
	// A.10. END ----------------------------------------------------------------------------------------------------------

	// A.11. Ajax Load More for PR pages ----------------------------------------------------------------------------------
	function load_more_press_release(e, button) {
		e.preventDefault();
		(isotope = button.attr("data-isotope-class")),
			(data = {
				action: "loadmore_ajax_handler",
				query: posts_pr,
				page: current_page_pr,
			});
		$.ajax({
			// you can also use $.post here
			url: scripts_params.ajaxurl, // AJAX handler
			data: data,
			type: "POST",
			beforeSend: function (xhr) {
				button.text("Loading..."); // change the button text, you can also add a preloader image
			},
			success: function (data) {
				if (data) {
					button
						.text("View more")
						.parent()
						.parent()
						.siblings(".isotope-grid")
						.append(data); // insert new posts
					if (typeof isotope !== undefined) {
						$("." + isotope)
							.isotope("reloadItems")
							.isotope();
					}
					current_page_pr++;

					if (current_page_pr.toString() === max_page_pr.toString()) {
						button.remove(); // if last page, remove the button
					}
					initialise_news_listing_cards();

					// you can also fire the "post-load" event here if you use a plugin that requires it
					// $( document.body ).trigger( 'post-load' );
				} else {
					button.remove(); // if no data, remove the button as well
				}
			},
		});
	}

	$(".ajax_read_more_pr").click(function (e) {
		load_more_press_release(e, $(this));
	});
	// A.11. END ---------------------------------------------------------------------------------------------------------

	// A.11. Ajax Load More for RR pages ----------------------------------------------------------------------------------
	function load_more_rr(e, button) {
		e.preventDefault();
		(isotope = button.attr("data-isotope-class")),
			(data = {
				action: "loadmore_ajax_handler",
				query: posts_rr,
				page: current_page_rr,
			});
		$.ajax({
			// you can also use $.post here
			url: scripts_params.ajaxurl, // AJAX handler
			data: data,
			type: "POST",
			beforeSend: function (xhr) {
				button.text("Loading..."); // change the button text, you can also add a preloader image
			},
			success: function (data) {
				if (data) {
					button
						.text("View more")
						.parent()
						.parent()
						.siblings(".isotope-grid")
						.append(data); // insert new posts
					if (isotope !== undefined) {
						$("." + isotope)
							.isotope("reloadItems")
							.isotope();
					}
					current_page_rr++;

					if (current_page_rr.toString() === max_page_rr.toString()) {
						button.remove(); // if last page, remove the button
					}
					initialise_news_listing_cards();

					// you can also fire the "post-load" event here if you use a plugin that requires it
					// $( document.body ).trigger( 'post-load' );
				} else {
					button.remove(); // if no data, remove the button as well
				}
			},
		});
	}

	$(".ajax_read_more_rr").click(function (e) {
		load_more_rr(e, $(this));
	});
	// A.11. END ---------------------------------------------------------------------------------------------------------

	// A.12. Scroll to # ----------------------------------------------------------------------------------

	var speed = 1000;

	// check for hash and if div exist... scroll to div
	var hash = window.location.hash;
	if ($(hash).length) scrollToID(hash, speed);

	function scrollToID(id, speed) {
		var offSet = 95;
		var obj = $(id).offset();
		var targetOffset = obj.top - offSet;
		$("html,body").animate({ scrollTop: targetOffset }, speed);
	}

	// A.12. END ---------------------------------------------------------------------------------------------------------

	// A.13. START -------------------------------------------------------------------------------------------------------
	var modal_animation_time = 500;

	function open_modal(modal) {
		modal
			.fadeIn(modal_animation_time)
			.find(".close-modal")
			.off()
			.on("click", function (e) {
				e.preventDefault();
				close_modal(modal);
			});
	}

	function close_modal(modal) {
		modal.fadeOut(modal_animation_time);
	}

	// A.13. END ---------------------------------------------------------------------------------------------------------

	// A.13. Ajax Load More -----------------------------------------------------------------------------------------------
	$(".search_ajax_read_more").click(function (e) {
		e.preventDefault();
		var button = $(this),
			data = {
				action: "search_loadmore_ajax_handler",
				query: posts_sr,
				page: current_page_sr,
			};
		$.ajax({
			url: scripts_params.ajaxurl,
			data: data,
			type: "POST",
			beforeSend: function (xhr) {
				button.text("Loading...");
			},
			success: function (data) {
				if (data) {
					$("#search-results-container").append(data);
					current_page_sr++;
					button.text("View more");
					if (current_page_sr.toString() === max_page_sr.toString()) {
						button.remove();
					}
				} else {
					button.remove();
				}
			},
		});
	});
	// A.13. END ----------------------------------------------------------------------------------------------------------

	// A.14. Ajax Resources Filtration -----------------------------------------------------------------------------------------------
	jQuery(document).ready(function () {
		initFiltration();
	});

	function initFiltration() {
		var container = jQuery(".loadmore-container");

		if (container.length) {
			container.each(function () {
				var holder = container.find(".loadmore-holder");
				var form = container.find(".filter-form");
				var pagination = container.find(".pagination-holder");
				initPagination();

				form.on("change", function (e) {
					e.preventDefault();
					jQuery.ajax({
						url: form.attr("action"),
						data: form.serialize(),
						type: "GET",
						success: function (responce) {
							holder.html(jQuery(responce).find(".loadmore-holder").html());
							pagination.html(
								jQuery(responce).find(".pagination-holder").html()
							);
							initPagination();
						},
					});
				});

				function initPagination() {
					var paginationLinks = pagination.find("a.page-numbers");
					paginationLinks.on("click", function (e) {
						e.preventDefault();
						console.log(jQuery(this).attr("href"));
						jQuery.ajax({
							url: jQuery(this).attr("href"),
							type: "GET",
							success: function (responce) {
								holder.html(jQuery(responce).find(".loadmore-holder").html());
								pagination.html(
									jQuery(responce).find(".pagination-holder").html()
								);
								initPagination();
							},
						});
					});
				}
			});
		}
	}

	// A.14. END ----------------------------------------------------------------------------------------------------------

	// A.15 Initialize each block on page load (front end). -----------------------------------------------------------------------------------------------

	function initialise_news_listing_cards() {
		$(".o-news-listing").each(function () {
			initLatestNews($(this));
		});
	}

	initialise_news_listing_cards();

	// A.15. END ----------------------------------------------------------------------------------------------------------

	// A.14. Main menu logic -----------------------------------------------------------------------------------------------

	const menuToggle = document.querySelector(".primary-nav-toggle");
	const header = document.querySelector(".site-header");
	const mainContent = document.querySelector("#gutenberg_body_wide");
	const footer = document.querySelector("#footer");

	/**
	 * Close open flyout menu
	 */
	function closeFlyouts() {
		const flyoutLinks = document.querySelectorAll(
			".primary-nav__link[aria-haspopup][aria-expanded='true']"
		);

		Array.prototype.forEach.call(flyoutLinks, function (item) {
			item.setAttribute("aria-expanded", "false");
		});
	}

	/**
	 * Handles the showing and hiding functionality
	 *
	 * @param {Object} e Toggle button
	 * @param {Boolean} isTopLevel If the nav item is top level
	 */
	const flyoutToggle = (e, isTopLevel = false) => {
		if (e.getAttribute("aria-expanded") === "false") {
			if (isTopLevel) closeFlyouts();
			e.setAttribute("aria-expanded", "true");
		} else {
			e.setAttribute("aria-expanded", "false");
		}
	};

	/**
	 * Close flyouts and mobile nav
	 */
	function closeFlyoutsAndNav() {
		closeFlyouts();
		menuToggle.setAttribute("aria-expanded", "false");
		mainContent.removeAttribute("inert");
		footer.removeAttribute("inert");
	}

	/**
	 * Changes nav items with children to a button
	 *
	 * @param {Object} e Element to change
	 * @param {Boolean} isTopLevel If the nav item is top level
	 */
	function changeToNavButton(e, isTopLevel = true) {
		const d = document.createElement("button");
		d.innerHTML = e.innerHTML;
		d.setAttribute("type", "button");
		d.setAttribute("aria-expanded", "false");
		d.setAttribute("aria-haspopup", "true");
		isTopLevel
			? d.classList.add("primary-nav__link")
			: d.classList.add("primary-nav__sub-link");
		d.classList.add("header-nav__link");
		d.classList.add("fancy-link-hover");
		if (e.parentNode.classList.contains("current-menu-ancestor"))
			d.setAttribute("aria-current", "true");
		d.dataset.state = e.dataset.state || false;

		d.addEventListener("click", () => {
			flyoutToggle(d, isTopLevel);
		});

		e.parentNode.replaceChild(d, e);
	}

	/**
	 * Initilise nav
	 */
	const initNav = () => {
		// Get all nav items with children and add click event to toggle visibility
		const topLevelHasChildren = document.querySelectorAll(
			".menu > .menu-item-has-children"
		);
		const subLevelHasChildren = document.querySelectorAll(
			".sub-menu > .menu-item-has-children"
		);

		Array.prototype.forEach.call(topLevelHasChildren, (child) => {
			const link = child.querySelector("a");
			changeToNavButton(link);
		});

		Array.prototype.forEach.call(subLevelHasChildren, (child) => {
			const link = child.querySelector("a");
			changeToNavButton(link, false);
		});

		menuToggle.addEventListener("click", () => {
			const menuExpanded = menuToggle.getAttribute("aria-expanded") === "false";
			menuToggle.setAttribute("aria-expanded", menuExpanded);

			if (menuExpanded) {
				mainContent.setAttribute("inert", "true");
				footer.setAttribute("inert", "true");
			} else {
				mainContent.removeAttribute("inert");
				footer.removeAttribute("inert");
			}
		});

		// Close flyout if click outside of it on desktop
		document.addEventListener("click", (e) => {
			// If user clicks inside the element, do nothing
			if (e.target.closest(".menu-item-has-children")) {
				return;
			}

			closeFlyouts();
		});

		// Close submenus and main menu (on mobile) if ESC key is pressed
		document.addEventListener("keydown", (e) => {
			if (e.key !== "Escape") {
				return;
			}

			closeFlyoutsAndNav();
		});

		// Close mobile menu and remove inert attribute on resize
		const menuResize = debounce(function () {
			if (window.innerWidth > 895) {
				closeFlyoutsAndNav();
			}
		}, 1000);

		window.addEventListener("resize", menuResize);
	};

	initNav();

	// A.16. END ----------------------------------------------------------------------------------------------------------

	// A. END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

	function init_asset_nav() {
		// Create a variable that contains the asset navigation.
		var navigation = jQuery("#campaigns-navigation");

		// Check if the navigation exists. We do not want to run anything if it does not.
		if (navigation.length > 0) {
			// Remove the disabled class as soon as this javaScript is available.
			navigation.removeClass("disabled");
			// Create a variable that contains the clickable buttons and folders and the container for the latest assets.
			var buttons = jQuery(".mcs-campaign-name"),
				folders = jQuery(".mcs-folder-name"),
				container = jQuery("#latest-assets");

			// Check if those buttons exists on the page.
			if (buttons.length > 0) {
				// If they do, the bind a click event to them.
				buttons.on("click", function (e) {
					// Prevent default action if button was changed to anchor tag instead of button.
					e.preventDefault();
					// Create variables for the button clicked and its sub navigation.
					var button = jQuery(this),
						subNav = button.siblings(".mcs-campaign-assets"),
						openFolder = jQuery(".mcs-folder-name.open"),
						openFolderSubNav = openFolder.siblings(".mcs-campaign-assets"),
						data,
						text = "";

					// Check that the navigation does not have the disabled class. If this class exists, we don't want to do anything.
					if (!navigation.hasClass("disabled")) {
						// If it does not have the class, it means a click has taken place and we want to disable it.
						navigation.addClass("disabled");
						// Check if the button clicked was already open.
						if (button.hasClass("open")) {
							// If it was, then simply remove the open class and close the sub navigation.
							button.removeClass("open");
							subNav.slideUp(300);

							// Set the AJAX data variable.
							data = {
								action: "get_latest_assets_html",
							};
							text = "From all non-restricted campaigns";
						} else {
							// If it was not open, we need variables for any open buttons, folders and their sub navigation.
							var openButton = jQuery(".mcs-campaign-name.open"),
								openSubNav = openButton.siblings(".mcs-campaign-assets");
							// Check if any open buttons exists.
							if (openButton.length > 0) {
								// If it does, we need to close it.
								openButton.removeClass("open");
								openSubNav.slideUp(300);
							}
							// Open the clicked button and its sub navigation.
							button.addClass("open");
							subNav.slideDown(300);

							// Set the AJAX data variable.
							data = {
								action: "get_latest_campaign_assets_html",
								id: button.data("id"),
							};
							text = "From " + button.text();
						}
						// Check if any open folders exists.
						if (openFolder.length > 0) {
							// If it does, we need to close it
							openFolder.removeClass("open");
							openFolderSubNav.slideUp(300);
						}
						// Check if the ajaxUrl variable is available for use.
						if (typeof scripts_params.ajaxurl !== "undefined") {
							// Set loader top position.
							set_loader_top_position(container);
							// Show preloader
							var preloader = container.find(".m-preloader");
							preloader.fadeIn(300);
							// Fetch the 6 latest assets for this campaign.
							jQuery.post(scripts_params.ajaxurl, data, function (response) {
								// Replace the HTML.
								jQuery("#latest-asset-container").empty().html(response);
								jQuery("#latest-assets .a-angled-heading + p").text(text);
								// Hide preloader
								preloader.fadeOut(300);
								// Remove the disabled class from the navigation.
								navigation.removeClass("disabled");
							});
						}
					}
				});
			}

			// Check if those folders exists on the page.
			if (folders.length > 0) {
				// If they do, the bind a click event to them.
				folders.on("click", function (e) {
					// Prevent default action if folder was changed to anchor tag instead of button.
					e.preventDefault();
					// Create variables for the folder clicked and its sub navigation.
					var folder = jQuery(this),
						folderSubNav = folder.siblings(".mcs-campaign-assets"),
						openCampaign = jQuery(".mcs-campaign-name.open"),
						data,
						text = "";

					// Check that the navigation does not have the disabled class. If this class exists, we don't want to do anything.
					if (!navigation.hasClass("disabled")) {
						// If it does not have the class, it means a click has taken place and we want to disable it.
						navigation.addClass("disabled");
						// Check if the folder clicked was already open.
						if (folder.hasClass("open")) {
							// If it was, then simply remove the open class and close the sub navigation.
							folder.removeClass("open");
							folderSubNav.slideUp(300);

							// Set the AJAX data variable.
							data = {
								action: "get_latest_campaign_assets_html",
								id: openCampaign.data("id"),
							};
							text = "From " + openCampaign.text();
						} else {
							// If it was not open, we need variables for any open folders and their sub navigation.
							var openFolder = jQuery(".mcs-folder-name.open"),
								openFolderSubNav = openFolder.siblings(".mcs-campaign-assets");
							// Check if any open folders exists.
							if (openFolder.length > 0) {
								// If it does, we need to close it
								openFolder.removeClass("open");
								openFolderSubNav.slideUp(300);
							}
							// Open the clicked folder and its sub navigation.
							folder.addClass("open");
							folderSubNav.slideDown(300);

							// Set the AJAX data variable.
							data = {
								action: "get_latest_folder_assets_html",
								id: folder.data("id"),
							};
							text = "From the " + folder.text() + " Folder";
						}
						// Check if the ajaxUrl variable is available for use.
						if (typeof scripts_params.ajaxurl !== "undefined") {
							// Set loader top position.
							set_loader_top_position(container);
							// Show preloader
							var preloader = container.find(".m-preloader");
							preloader.fadeIn(300);
							// Fetch the 6 latest assets for this campaign or folder.
							jQuery.post(scripts_params.ajaxurl, data, function (response) {
								// Replace the HTML.
								jQuery("#latest-asset-container").empty().html(response);
								jQuery("#latest-assets .a-angled-heading + p").text(text);
								// Hide preloader
								preloader.fadeOut(300);
								// Remove the disabled class from the navigation.
								navigation.removeClass("disabled");
							});
						}
					}
				});
			}
		}
	}
	init_asset_nav();

	function set_loader_top_position(container) {
		var posTop = jQuery(window).innerHeight() - container.offset().top;

		if (posTop > 50) {
			container.find(".m-loader").css({
				top: posTop / 2 + "px",
			});
		}
	}

	// file - saver

	initFileSaver();

	function initFileSaver() {
		window.addEventListener("click", function (e) {
			if (e.target.hasAttribute("download")) {
				e.preventDefault();
				var href = e.target.href;
				var fileName = href.split("/");
				fileName = fileName[fileName.length - 1];
				window.saveAs(href, fileName);
			}
		});
	}

	(function (global, factory) {
		if (typeof define === "function" && define.amd) {
			define([], factory);
		} else if (typeof exports !== "undefined") {
			factory();
		} else {
			var mod = {
				exports: {},
			};
			factory();
			global.FileSaver = mod.exports;
		}
	})(window, function () {
		"use strict";

		/*
		 * FileSaver.js
		 * A saveAs() FileSaver implementation.
		 *
		 * By Eli Grey, http://eligrey.com
		 *
		 * License : https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md (MIT)
		 * source  : http://purl.eligrey.com/github/FileSaver.js
		 */
		// The one and only way of getting global scope in all environments
		// https://stackoverflow.com/q/3277182/1008999
		var _global =
			typeof window === "object" && window.window === window
				? window
				: typeof self === "object" && self.self === self
				? self
				: typeof global === "object" && global.global === global
				? global
				: void 0;

		function bom(blob, opts) {
			if (typeof opts === "undefined")
				opts = {
					autoBom: false,
				};
			else if (typeof opts !== "object") {
				console.warn("Deprecated: Expected third argument to be a object");
				opts = {
					autoBom: !opts,
				};
			} // prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF

			if (
				opts.autoBom &&
				/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(
					blob.type
				)
			) {
				return new Blob([String.fromCharCode(0xfeff), blob], {
					type: blob.type,
				});
			}

			return blob;
		}

		function download(url, name, opts) {
			var xhr = new XMLHttpRequest();
			xhr.open("GET", url);
			xhr.responseType = "blob";

			xhr.onload = function () {
				saveAs(xhr.response, name, opts);
			};

			xhr.onerror = function () {
				console.error("could not download file");
			};

			xhr.send();
		}

		function corsEnabled(url) {
			var xhr = new XMLHttpRequest(); // use sync to avoid popup blocker

			xhr.open("HEAD", url, false);

			try {
				xhr.send();
			} catch (e) {}

			return xhr.status >= 200 && xhr.status <= 299;
		} // `a.click()` doesn't work for all browsers (#465)

		function click(node) {
			try {
				node.dispatchEvent(new MouseEvent("click"));
			} catch (e) {
				var evt = document.createEvent("MouseEvents");
				evt.initMouseEvent(
					"click",
					true,
					true,
					window,
					0,
					0,
					0,
					80,
					20,
					false,
					false,
					false,
					false,
					0,
					null
				);
				node.dispatchEvent(evt);
			}
		} // Detect WebView inside a native macOS app by ruling out all browsers
		// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
		// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos

		var isMacOSWebView =
			/Macintosh/.test(navigator.userAgent) &&
			/AppleWebKit/.test(navigator.userAgent) &&
			!/Safari/.test(navigator.userAgent);
		var saveAs =
			_global.saveAs || // probably in some web worker
			(typeof window !== "object" || window !== _global
				? function saveAs() {}
				: /* noop */
				// Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView
				"download" in HTMLAnchorElement.prototype && !isMacOSWebView
				? function saveAs(blob, name, opts) {
						var URL = _global.URL || _global.webkitURL;
						var a = document.createElement("a");
						name = name || blob.name || "download";
						a.download = name;
						a.rel = "noopener"; // tabnabbing
						// TODO: detect chrome extensions & packaged apps
						// a.target = '_blank'

						if (typeof blob === "string") {
							// Support regular links
							a.href = blob;

							if (a.origin !== location.origin) {
								corsEnabled(a.href)
									? download(blob, name, opts)
									: click(a, (a.target = "_blank"));
							} else {
								click(a);
							}
						} else {
							// Support blobs
							a.href = URL.createObjectURL(blob);
							setTimeout(function () {
								URL.revokeObjectURL(a.href);
							}, 4e4); // 40s

							setTimeout(function () {
								click(a);
							}, 0);
						}
				  } // Use msSaveOrOpenBlob as a second approach
				: "msSaveOrOpenBlob" in navigator
				? function saveAs(blob, name, opts) {
						name = name || blob.name || "download";

						if (typeof blob === "string") {
							if (corsEnabled(blob)) {
								download(blob, name, opts);
							} else {
								var a = document.createElement("a");
								a.href = blob;
								a.target = "_blank";
								setTimeout(function () {
									click(a);
								});
							}
						} else {
							navigator.msSaveOrOpenBlob(bom(blob, opts), name);
						}
				  } // Fallback to using FileReader and a popup
				: function saveAs(blob, name, opts, popup) {
						// Open a popup immediately do go around popup blocker
						// Mostly only available on user interaction and the fileReader is async so...
						popup = popup || open("", "_blank");

						if (popup) {
							popup.document.title = popup.document.body.innerText =
								"downloading...";
						}

						if (typeof blob === "string") return download(blob, name, opts);
						var force = blob.type === "application/octet-stream";

						var isSafari =
							/constructor/i.test(_global.HTMLElement) || _global.safari;

						var isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);

						if (
							(isChromeIOS || (force && isSafari) || isMacOSWebView) &&
							typeof FileReader !== "undefined"
						) {
							// Safari doesn't allow downloading of blob URLs
							var reader = new FileReader();

							reader.onloadend = function () {
								var url = reader.result;
								url = isChromeIOS
									? url
									: url.replace(/^data:[^;]*;/, "data:attachment/file;");
								if (popup) popup.location.href = url;
								else location = url;
								popup = null; // reverse-tabnabbing #460
							};

							reader.readAsDataURL(blob);
						} else {
							var URL = _global.URL || _global.webkitURL;
							var url = URL.createObjectURL(blob);
							if (popup) popup.location = url;
							else location.href = url;
							popup = null; // reverse-tabnabbing #460

							setTimeout(function () {
								URL.revokeObjectURL(url);
							}, 4e4); // 40s
						}
				  });
		_global.saveAs = saveAs.saveAs = saveAs;
		if (typeof module !== "undefined") {
			module.exports = saveAs;
		}
	});

	jQuery(".filter-btn").on("click", function (e) {
		var el = $(e.target);
		if (e.keyCode == 13) {
			var input = el.parent().find("input");
			input.prop("checked", true);
			input.trigger("change");
		}
	});
	jQuery(".filter-btn").on("click", function () {
		jQuery("html, body").animate(
			{
				scrollTop: $("#resource_filters").offset().top,
			},
			2000
		);
	});

	// $('textarea').keyup(function (e) {
	// 	if (e.keyCode == 13) {
	// 		console.log('test)
	// }
	// });

	// Video player hover function
	// jQuery('.lab-information-image-video').hover(function() {
	//         jQuery(this).find('.embed-container').css('z-index', 25);
	//     },function() {
	//         jQuery(this).find('.embed-container').css('z-index', 10);
	//     }
	// );
});

// Download File/Preview File functions

function downloadFile(event) {
	event.preventDefault();
	event.stopPropagation();
	// Download href
	var link = event.target.href;
	// Download the file in the browser
	var w = window.open(link, "_self");
}

function previewFile(event) {
	event.preventDefault();
	event.stopPropagation();
	// Show href
	var link = event.target.href;
	// Download the file in the browser
	var w = window.open(link, "_blank");
}

jQuery(document).ready(function ($) {
	function resourceFilterInit() {
		const resourceFilter = document.getElementById("resource_filters");

		if (!resourceFilter) return;

		const url = new URL(window.location.href);

		// If we have a category selected scroll to filter bar
		if (url?.search.includes("resource_cat")) {
			resourceFilter.scrollIntoView();
		}
	}

	resourceFilterInit();
});

// FILE END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

// });
(function($){

    /**
     * LAB - FAQ Quick Links
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    23/01/2020
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {

    };

    // Initialize each block on page load (front end).
    $('.lab-faq-quick-links').each(function () {
        initializeBlock($(this));
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=faq_quick_links', initializeBlock );
    }

})(jQuery);

(function($){

    /**
     * LAB - Page Header Three
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    04/02/2020
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {

        /*var text = prepHeading();
        setTimeout(function(){
            typeHeading(text.split(''));
        }, 500);*/

        polyfill_images($block);

    };

    // IE Object Fit Polyfill
    function polyfill_images(container){
        var images = container.find('.polyfill-image');

        if(images.length > 0){
            objectFitImages(images);
        }
    }

    /*function prepHeading(){
        var heading = $('.lab-page-header-three h1'),
            headingText = heading.text();
        heading.text('');
        return headingText;
    }

    function typeHeading(text){
        var heading = $('.lab-page-header-three h1');
        if(text.length > 0){
            if(!heading.hasClass('typing')){
                heading.addClass('typing');
            }

            setTimeout(function(){
                heading.text(heading.text() + text[0]);
                text.shift();
                typeHeading(text);
            }, 50);
        } else {
           heading.removeClass('typing').addClass('typed');
        }
    }*/

    // Initialize each block on page load (front end).
    $('.lab-page-header-three').each(function () {
        initializeBlock($(this));
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=lab_page_header_three', initializeBlock );
    }

})(jQuery);
